// @ts-nocheck

// Capture variant:update events fired before Alpine components initialise
let _pendingVariant = null;
document.addEventListener('variant:update', (e) => {
  if (e.detail?.resource) _pendingVariant = e.detail.resource;
});

// Track variant:selected so components can disable ATC immediately on swatch click
let _variantSelecting = false;
document.addEventListener('variant:selected', () => {
  _variantSelecting = true;
});

document.addEventListener('alpine:init', () => {
  const approvedPlanIds = new Set([2274525299, 2274558067, 2274590835, 2274623603]);
  Alpine.data('ctrSubBuyBox', () => ({
    purchaseType: 'subscription',
    currentSellingPlanId: null,
    variantId: null,
    variantPrice: 0,
    unitCount: 0,
    unitLabel: '',
    sellingPlanAllocations: [],
    hasSellingPlans: false,
    loading: false,
    variantUpdating: false,

    init() {
      this._readDataAttributes();

      // Apply any variant:update that fired before this component initialised
      if (_pendingVariant) {
        this._applyVariant(_pendingVariant);
      }

      // Sync the updating state in case variant:selected already fired before init
      this.variantUpdating = _variantSelecting;

      // Disable ATC immediately when the user clicks a swatch (before XHR returns)
      this._onVariantSelected = () => {
        this.variantUpdating = true;
      };

      // Listen for future variant changes from the variant picker
      this._onVariantUpdate = (event) => {
        const variant = event.detail?.resource;
        if (!variant) return;
        _pendingVariant = variant;
        _variantSelecting = false;
        this.variantUpdating = false;
        this._applyVariant(variant, event.detail?.data?.html);
      };

      document.addEventListener('variant:selected', this._onVariantSelected);
      document.addEventListener('variant:update', this._onVariantUpdate);

      // Watch for attribute changes caused by the plan picker morphing the section
      // with a different product (data-variant-id changes → re-read all data attrs)
      this._attrObserver = new MutationObserver(() => {
        this._readDataAttributes(true);
        _pendingVariant = null;
        this._broadcastState();
      });
      this._attrObserver.observe(this.$el, {
        attributes: true,
        attributeFilter: ['data-variant-id'],
      });

      // Broadcast state whenever purchase type or selling plan frequency changes
      this.$watch('purchaseType', () => this._broadcastState());
      this.$watch('currentSellingPlanId', () => this._broadcastState());
      this.$watch('variantId', () => this._broadcastState());

      // Respond to sticky ATC requesting current state (handles init order race)
      this._onRequestState = () => this._broadcastState();
      document.addEventListener('ctr:buybox:request-state', this._onRequestState);

      // Broadcast initial state so the sticky ATC can sync on load
      this._broadcastState();
    },

    destroy() {
      document.removeEventListener('variant:selected', this._onVariantSelected);
      document.removeEventListener('variant:update', this._onVariantUpdate);
      document.removeEventListener('ctr:buybox:request-state', this._onRequestState);
      if (this._attrObserver) {
        this._attrObserver.disconnect();
        this._attrObserver = null;
      }
    },

    _broadcastState() {
      document.dispatchEvent(
        new CustomEvent('ctr:buybox:change', {
          detail: {
            purchaseType: this.purchaseType,
            currentSellingPlanId: this.currentSellingPlanId,
            sellingPlanAllocations: this.sellingPlanAllocations,
            variantId: this.variantId,
            variantPrice: this.variantPrice,
          },
        })
      );
    },

    _readDataAttributes(preservePurchaseType = false) {
      const d = this.$el.dataset;
      const hasSellingPlans = d.hasSellingPlans === 'true';
      const configuredDefault = d.defaultPurchaseType || 'subscription';
      if (!preservePurchaseType) {
        this.purchaseType = hasSellingPlans ? configuredDefault : 'one-time';
      } else if (!hasSellingPlans) {
        this.purchaseType = 'one-time';
      }
      this.currentSellingPlanId = d.defaultSellingPlanId ? parseInt(d.defaultSellingPlanId, 10) : null;
      this.variantId = parseInt(d.variantId, 10);
      this.variantPrice = parseInt(d.variantPrice, 10) || 0;
      this._parseBadgeLabel(d.countBadgeLabel || '');
      try {
        this.sellingPlanAllocations = JSON.parse(d.sellingPlanAllocations || '[]')
          .filter((a) => approvedPlanIds.has(Number(a.selling_plan_id)));
      } catch (e) {
        this.sellingPlanAllocations = [];
      }
      this.hasSellingPlans = this.sellingPlanAllocations.length > 0;
      if (!this.hasSellingPlans) {
        this.currentSellingPlanId = null;
        this.purchaseType = 'one-time';
      }
    },

    _applyVariant(variant, newHtml) {
      this.variantId = variant.id;
      this.variantPrice = variant.price || 0;

      const allocations = (variant.selling_plan_allocations || [])
        .filter((a) => approvedPlanIds.has(Number(a.selling_plan_id)))
        .map((a) => ({
          selling_plan_id: a.selling_plan_id,
          price: a.price,
          compare_at_price: a.compare_at_price,
        }));
      this.sellingPlanAllocations = allocations;

      if (allocations.length > 0) {
        const planStillValid = allocations.find((a) => a.selling_plan_id === this.currentSellingPlanId);
        if (!planStillValid) {
          this.currentSellingPlanId = allocations[0].selling_plan_id;
        }
        if (!this.hasSellingPlans) {
          const configuredDefault = this.$el.dataset.defaultPurchaseType || 'subscription';
          this.purchaseType = configuredDefault;
        }
        this.hasSellingPlans = true;
      } else {
        this.sellingPlanAllocations = [];
        this.currentSellingPlanId = null;
        this.purchaseType = 'one-time';
        this.hasSellingPlans = false;
      }

      if (newHtml) {
        const newEl = newHtml.querySelector('[data-count-badge-label]');
        if (newEl) this._parseBadgeLabel(newEl.dataset.countBadgeLabel || '');
      }

      this._broadcastState();
    },

    _parseBadgeLabel(label) {
      const text = (label || '').trim();
      if (!text) { this.unitCount = 0; this.unitLabel = ''; return; }
      const parts = text.split(/\s+/);
      const count = parseInt(parts[0], 10);
      if (count > 0) {
        this.unitCount = count;
        const word = (parts.slice(1).join(' ') || '').toLowerCase();
        this.unitLabel = word.replace(/s$/i, '');
      } else {
        this.unitCount = 0;
        this.unitLabel = '';
      }
    },

    get currentAllocation() {
      if (!this.currentSellingPlanId) return this.sellingPlanAllocations[0] || null;
      return (
        this.sellingPlanAllocations.find(
          (a) => a.selling_plan_id === this.currentSellingPlanId
        ) || this.sellingPlanAllocations[0] || null
      );
    },

    get subscriptionPriceDisplay() {
      const alloc = this.currentAllocation;
      if (!alloc) return '';
      return this._formatPriceWithUnit(alloc.price);
    },

    get comparePriceDisplay() {
      const alloc = this.currentAllocation;
      if (!alloc) return '';
      return this._formatPriceWithUnit(alloc.compare_at_price || this.variantPrice);
    },

    get otpPriceDisplay() {
      return this._formatPriceWithUnit(this.variantPrice);
    },

    _formatPriceWithUnit(cents) {
      const formatted = this._formatMoney(cents);
      if (this.unitCount > 0 && this.unitLabel) {
        const perUnit = this._formatMoney(Math.round(cents / this.unitCount));
        return `${formatted} | ${perUnit} per ${this.unitLabel}`;
      }
      return formatted;
    },

    _formatMoney(cents) {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
        minimumFractionDigits: 2,
      }).format(cents / 100);
    },

    onChangeFrequency(event) {
      this.currentSellingPlanId = parseInt(event.target.value, 10);
    },

    async addToCart(event) {
      this.loading = true;

      const body = {
        id: this.variantId,
        quantity: 1,
      };

      if (this.purchaseType === 'subscription' && this.currentSellingPlanId) {
        body.selling_plan = this.currentSellingPlanId;
      }

      // R-TAP (17 Sep 2026): the drawer opens on the tap. It used to open after
      // the await, so the button was pressed and nothing happened for the whole
      // round trip. The line morphs in when the response lands; until then the
      // drawer carries data-cart-pending (see assets/cart-drawer.js).
      const cartDrawer = /** @type {any} */ (document.querySelector('cart-drawer-component'));
      cartDrawer?.openForPendingAdd?.({ source: event?.currentTarget ?? event?.target ?? null });

      // R57c-4: the whole round trip belongs to cartController.add() now - see
      // the note in ctr-sticky-atc.js.
      try {
        if (!window.cartController?.add) {
          console.error('[ctr-sub-buy-box] cart-controller.js is not loaded; no cart request was sent');
          window.ctrNotifyCartFailure(
            'Sorry, your basket could not be updated. Please refresh the page and try again.',
            'ctr-sub-buy-box'
          );
          return;
        }

        const result = await window.cartController.add(body, { source: 'ctr-sub-buy-box' });

        // R89: no notify here on purpose. Everything that gets as far as add()
        // is surfaced by cart-controller.js before it returns, so telling the
        // customer again would show the same message twice.
        // R89: no notify here on purpose (see above). The drawer stays OPEN on a
        // refusal - it is where cart-controller.js has just put the message, and
        // shutting it would take the explanation away with it. Clearing the
        // pending mark is enough; the reconcile has already morphed the truth in.
        if (!result.ok) return;

        // R-TAP-ANIM, round TAP-12 finding 1: NO unconditional open() here any more.
        // It reopened the drawer after the response on a basket that already had
        // items, which is exactly what Charlie asked not to happen. The tap-time
        // call above is the only decision, and it flew the photo instead.
      } catch (err) {
        console.error('[ctr-sub-buy-box] Add to cart failed:', err);
        window.ctrNotifyCartFailure(
          'Sorry, your basket could not be updated. Please try again.',
          'ctr-sub-buy-box',
          err
        );
      } finally {
        // A refused subscription add returns from cartController.add() WITHOUT
        // reconciling, so no cart update is coming to lift the pending mark.
        cartDrawer?.clearPendingAdd?.();
        this.loading = false;
      }
    },
  }));
});
